import Helper from '@ember/component/helper';
import { service } from '@ember/service';

/**
 * This IsRouteActive helper checks if the provided list of route names includes an active route
 *
 * @param {Array}  routeNames   Required. Array of route names
 * @param {Object} params       Optional. Route parameters to match
 */
export default class IsRouteActive extends Helper {
  @service router;

  compute([routeNames, params]) {
    if (!Array.isArray(routeNames)) {
      routeNames = [routeNames];
    }

    if (this.router.currentRoute?.localName === 'loading') {
      return false;
    }

    // check if any of the route names match
    const routeMatches = routeNames.some((routeName) => this.router.isActive(routeName));

    if (!routeMatches) {
      return false;
    }

    // if params are provided, also check if they match
    if (params) {
      const currentParams = this.router.currentRoute.params;
      for (const [key, value] of Object.entries(params)) {
        if (currentParams[key] !== value) {
          return false;
        }
      }
    }

    return true;
  }
}
